import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, X } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/lib/utils';

interface CheckboxProps extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  feedbackState?: 'default' | 'correct' | 'incorrect';
}

const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
  ({ className, feedbackState = 'default', ...props }, ref) => {
    const getFeedbackStyles = () => {
      switch (feedbackState) {
        case 'correct':
          return 'border-green-500 bg-green-500 data-[state=checked]:bg-green-500';
        case 'incorrect':
          return 'border-red-500 bg-red-500 data-[state=checked]:bg-red-500';
        default:
          return 'border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground';
      }
    };

    const getIcon = () => {
      if (feedbackState === 'incorrect') {
        return <X className="h-4 w-4 text-white" />;
      }
      return <Check className="h-4 w-4" />;
    };

    return (
      <CheckboxPrimitive.Root
        ref={ref}
        className={cn(
          'peer h-4 w-4 shrink-0 rounded-sm border ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          getFeedbackStyles(),
          className
        )}
        {...props}
      >
        <CheckboxPrimitive.Indicator
          className={cn('flex items-center justify-center text-current')}
        >
          {getIcon()}
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
    );
  }
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
